export const OrderByOptions = {
  Downloads: 'MostDownloads',
  Installs: 'MostActiveInstalls',
  Relevance: 'RelevanceToSearchText',
  Created: 'MostRecentlyCreated',
  Modified: 'MostRecentlyModified',
  AZ: 'Alphabetical',
  ZA: 'ReverseAlphabetical',
  Popular: 'MostActiveInstalls',
  Recent: 'MostRecentlyCreated',
  Updated: 'MostRecentlyModified',
} as const;

export type OrderByOptions = typeof OrderByOptions[keyof typeof OrderByOptions];
